import styled, { AnyStyledComponent } from 'styled-components';

import BasepathsPattern from '../Basepaths/basepaths';
import COLORS from '../../style/universal.color';
import { activeClassname, basePathDataValueKey, homeBase } from '../Basepaths/constants';
import { BaseRect } from '../Basepaths/basepaths.style';

export const Basepaths: AnyStyledComponent = styled(BasepathsPattern)`
    ${BaseRect} {
        rx: 0;
        ry: 0;

        &:hover, &:focus {
            pointer-events: all;
            stroke: ${({ theme }) => theme.dark ? COLORS.mlbGrey2 : COLORS.mlbGrey3};
            fill: ${({ theme }) => theme.dark ? COLORS.mlbGrey2 : COLORS.mlbGrey3};
        }

        &.${activeClassname}:hover, &.${activeClassname}:focus {
            fill: ${COLORS.linkBlueOnDarkHover};
            stroke: ${COLORS.linkBlueOnDarkHover};
        }

        ${({enableHomeEvents}) => !enableHomeEvents && (`
            &[${basePathDataValueKey}="${homeBase}"] {
                    fill: transparent;
                }
        `)};
    }
`;
